import {generatePath, useHistory, useParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, {useEffect, useState} from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores, getUsuarios } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import {ROUTE_PACIENTES_CONTACTOLOGY_EDIT} from "../../../routes.constants";
import {faPrint} from "@fortawesome/pro-light-svg-icons";
import {descargarInforme} from "../../../state/actions/creators/informes.actioncreator";
import {Form} from "antd";

export function FichaContactologica({
  watch,
  create,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo, tiendaGraduacion } = params;
  const history = useHistory();
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const usuarios = useSelector(state => state.fichaOptometricaWorkspace.usuarios);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const sagas = useSelector(state => state.sagas);
  const idGraduacionContactologica = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica.codigo);
  const tiendaGraduacionContactologica_id = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica.tienda_id);
  const ultimaOptometriaSagaLoading = sagas.GET_GRADUACION_ULTIMA_OPTOMETRIA?.running;
  const contactologiaSagaLoading = sagas.GET_GRADUACION_CONTACTOLOGICA?.running;
  useEffect(() => {
    if (!paciente) {
      dispatch(getPaciente({ tiendaId, pacienteId }));
    }
    if (!prescriptores || prescriptores.length === 0) { 
      dispatch(getPrescriptores(null));
    }
    if (!usuarios || usuarios.length === 0) {
      dispatch(getUsuarios(null));
    }
    if (!create) {
      if(idGraduacionContactologica != codigo || tiendaGraduacionContactologica_id != tiendaGraduacion) dispatch(getDatosFichaContactologica(codigo, tiendaGraduacion ));
    } else {
      dispatch(getDatosUltimaOptometria(pacienteId));
    }
  }, []);

  const PichaContactologicaFormulario = Form.create()(FichaContactologicaFormulario);
  return (
    <Page
      titulo={paciente ? paciente.nombre_completo : `Ficha (${params.pacienteId})`}
      navigationItems={[
        {
          node: <Text upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
          link: '/pacientes/buscar',
        },
        {
          node: <Text upperCase={false} lowerCase={false}>{paciente ? paciente.nombre_completo : `Ficha (${params.pacienteId})`}</Text>,
          link: `/pacientes/file/${params.pacienteId}`,
        },
      ]}
      hasStickyActionsHeader={watch}
      loading={!paciente || (create && ultimaOptometriaSagaLoading) || contactologiaSagaLoading}
    >
      {paciente ? <PichaContactologicaFormulario create={create} watch={watch} /> : <LoadingWorkspaceSkeleton mt={0} hidePageTitle />}
    </Page>
  );
}
